// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let JsxRuntime = require("react/jsx-runtime");

function HtmlHolder(props) {
  let __proseStyle = props.proseStyle;
  let proseStyle = __proseStyle !== undefined ? __proseStyle : "sm";
  let proseClassName = proseStyle === "sm" ? "prose prose-sm" : "prose";
  let classNames = `whitespace-pre-line 
  prose-a:break-all prose-a:whitespace-pre-wrap prose-a:line-clamp-2 prose-a:overflow-hidden 
  prose-zinc prose-ul:list-disc prose-ol:list-decimal prose-a:inline
  ` + proseClassName + ` [&>p>br:only-child]:hidden first:prose-p:mt-0 first:prose-headings:mt-0 first:prose-ul:mt-0 first:prose-ol:mt-0 
  last:prose-p:mb-0 last:prose-headings:mb-0 last:prose-ul:mb-0 last:prose-ol:mb-0`;
  return JsxRuntime.jsx("div", {
    ref: props.innerRef,
    className: Stdlib_Option.mapOr(props.className, classNames, c => classNames + (" " + c)),
    dangerouslySetInnerHTML: {
      __html: props.innerHtml
    }
  });
}

let make = HtmlHolder;

exports.make = make;
/* react/jsx-runtime Not a pure module */
